const DITypes = {
  JsonRpcDispatcher: Symbol('CfrJsonRpcDispatcher'),
  DispatcherFactory: Symbol('CfrDispatcherFactory'),
  AdapterFactory: Symbol('CfrAdapterFactory'),
};

export default DITypes;
